// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"8db45346","549":"32b835a5"}[chunkId] + ".chunk.js";
};